import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

export interface StepNavItem {
    id: string;
    /** Translation key. */
    label: string;
    route: string;
    /** Material Symbols name, shown instead of a number for a page outside the sequence (an overview). */
    icon?: string;
}

interface StepNavView extends StepNavItem {
    number?: number;
    state: 'active' | 'past' | 'upcoming';
}

/**
 * The pages of a multi-step module as one line of numbered steps, the current one underlined like a tab.
 * Every step stays open whatever the progress: the order is a guide, not a lock.
 */
@Component({
    selector: 'app-step-nav',
    templateUrl: './step-nav.component.html',
    styleUrls: ['./step-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe],
})
export class StepNavComponent implements OnChanges {
    @Input({ required: true }) steps: StepNavItem[] = [];
    @Input({ required: true }) active = '';
    /** Translation key naming the module, read by screen readers. */
    @Input({ required: true }) ariaLabel = '';

    view: StepNavView[] = [];

    ngOnChanges(): void {
        const activeIndex = this.steps.findIndex((step) => step.id === this.active);
        let number = 0;
        this.view = this.steps.map((step, index) => ({
            ...step,
            number: step.icon ? undefined : ++number,
            state:
                index === activeIndex
                    ? 'active'
                    : !step.icon && activeIndex >= 0 && index < activeIndex
                      ? 'past'
                      : 'upcoming',
        }));
    }
}
